import { AIModel } from 'common/types';
import yusheng from 'common/service/yusheng';
import danqing from 'common/service/danqing';

export interface AiModelParams extends AIModel {
  pageIndex?: number;
  pageSize?: number;
}

// TODO AiModelParams 类型提取至 common
const setting = { ...yusheng, ...danqing };

export default setting;
